import React from 'react'

import { SmallText, Text } from './Text'
import Separator from '../helpers/Separator'
import { COLORS } from '@btime/constants'

const LabelValue = ({ label, value, children, ...props }) => {
  if (!value && !children) return false

  return (
    <div>
      <SmallText color={COLORS.dark3} size="xsmall">
        {label}
      </SmallText>
      {value && (
        <Text weight="500" {...props}>
          {value}
        </Text>
      )}
      <Separator />
      {children}
      <Separator />
    </div>
  )
}

export default LabelValue
